import { ReactElement } from 'react'
import { I18n } from 'src/i18n'
import { defaultTheme } from 'src/theme'
import { Button } from 'src/ui-components'
import styled from 'styled-components'
import FileUploadIcon from '@mui/icons-material/FileUpload'

interface Props {
  onSelect: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const SelectFile = (props: Props): ReactElement => {
  const { onSelect } = props
  return (
    <ImportFileContainer>
      <BrowseFileContainer>
        <FileUploadIcon
          style={{ color: defaultTheme.colors.columnBorder, scale: '2' }}
        />

        <I18n name="dragAndDrop" style={{ fontSize: '16px' }} />

        <I18n
          name="or"
          style={{ fontSize: '16px', textTransform: 'lowercase' }}
        />

        <Button text="browseFile" variant="primary" size="medium" />

        <BrowseFileFieldWrapper>
          <BrowseFileButton
            type="file"
            onChange={onSelect}
            title=""
            value=""
            accept=".csv"
          />
        </BrowseFileFieldWrapper>
      </BrowseFileContainer>
    </ImportFileContainer>
  )
}

const BrowseFileFieldWrapper = styled.div`
  height: 429px;
  width: 88%;
  cursor: pointer;
  position: absolute;
`

const ImportFileContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const BrowseFileContainer = styled.div`
  border: 2px;
  border-style: dashed;
  border-color: lightgrey;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 429px;
  gap: 16px;
`

export const BrowseFileButton = styled.input`
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`

export default SelectFile
